
<template>
  <div v-if="parseInt(item.Quan_price) != 0 || isWeixin" class="doublemain" @click="public.gotoDetail(item,types,idx)">
    <div class="row product-list">
      <div class="list-product-img1">
        <!--<img :src="img" v-view="updatePicSrc(item.Pic)" width="100%"/>-->
        <img :src="updatePicSrc(item.Pic)" width="100%"/>
        <span></span>
      </div>
      <div class="list-product-desc1">
        <div class="list-product-name1">
          {{item.D_title | limitStr(11)}}
        </div>
        <div class="list-prices" v-if="type==showType.APP">
          <div class="list-quan1">
            <span style="color:#d90000 ">¥</span><span class="list-quan1-price">{{item.Price}}</span>{{quanDesc}}
          </div>
          <div :class="showClass()">
            <div class="list-price1-price" v-show="isShowQuan">{{item.Quan_price|subPrice}}元券</div>
          </div>
          <div class="red-box-main">
            <div class="score">返{{returnScore()}}积分</div>
            <div class="salenum">{{item.Sales_num}}笔成交</div>
            <div style="clear: both"></div>
          </div>
        </div>
        <div class="list-prices-h5" v-else>
          <div class="list-quan1-h5">
            <div class="list-price1-quan-h5"><span style="color:#d90000 ">¥</span><span class="list-quan1-price-h5"
                                                                                        v-priceLimit="item.Price">{{item.Price}}</span><span
              class="list-quan1-desc-price-h5">{{quanDesc}}</span></div>
            <div class="list-price1-price-h5" v-show="isShowQuan">{{item.Quan_price|subPrice}}元券</div>
            <div style="clear: both"></div>
          </div>
          <div :class="showClass()">
            <div class="salenum-h5">{{item.Sales_num}}笔成交</div>
          </div>
          <!--<div class="red-box-main-h5">-->
          <!--<div class="score-h5">返{{returnScore()}}积分</div>-->

          <!--</div>-->
        </div>
      </div>
    </div>
  </div>
  <a :biz-itemid="item.GoodsID" isconvert=1  class="doublemain" target="_self" :href="'https://item.taobao.com/item.htm?id=' + item.GoodsID" v-else >
    <div class="row product-list">
      <div class="list-product-img1">
        <!--<img :src="img" v-view="updatePicSrc(item.Pic)" width="100%"/>-->
        <img :src="updatePicSrc(item.Pic)" width="100%"/>
        <span></span>
      </div>
      <div class="list-product-desc1">
        <div class="list-product-name1">
          {{item.D_title | limitStr(11)}}
        </div>
        <div class="list-prices" v-if="type==showType.APP">
          <div class="list-quan1">
            <span style="color:#d90000 ">¥</span><span class="list-quan1-price">{{item.Price}}</span>{{quanDesc}}
          </div>
          <div :class="showClass()">
            <div class="list-price1-price" v-show="isShowQuan">{{item.Quan_price|subPrice}}元券</div>
          </div>
          <div class="red-box-main">
            <div class="score">返{{returnScore()}}积分</div>
            <div class="salenum">{{item.Sales_num}}笔成交</div>
            <div style="clear: both"></div>
          </div>
        </div>
        <div class="list-prices-h5" v-else>
          <div class="list-quan1-h5">
            <div class="list-price1-quan-h5"><span style="color:#d90000 ">¥</span><span class="list-quan1-price-h5"
                                                                                        v-priceLimit="item.Price">{{item.Price}}</span><span
              class="list-quan1-desc-price-h5">{{quanDesc}}</span></div>
            <div class="list-price1-price-h5" v-show="isShowQuan">{{item.Quan_price|subPrice}}元券</div>
            <div style="clear: both"></div>
          </div>
          <div :class="showClass()">
            <div class="salenum-h5">{{item.Sales_num}}笔成交</div>
          </div>
          <!--<div class="red-box-main-h5">-->
          <!--<div class="score-h5">返{{returnScore()}}积分</div>-->

          <!--</div>-->
        </div>
      </div>
    </div>
  </a>
</template>
<script>
  export default{
    name: 'double',
    props: ['item', 'type', 'types', 'k', 'idx'],
    data(){
      return {
        img: require("../../../static/img/default.jpg"),
        isShowQuan: true,
        quanDesc: '',
        isWeixin: this.isWeixin,
        isAndroid: this.isAndroid
      }
    },
    filters: {
      limitStr: function (value, length) {
        if (value.length >= length) {
          return value.substr(0, length);
        } else {
          return value;
        }
      },
      subPrice: function (value) {
        if(value){
          var idx = value.indexOf(".");
          if (idx > -1) {
            value = value.slice(0, idx);
          }
          return value;
        } else {
            return 0
        }
      }

    },
    directives: {
      priceLimit: {
        bind: function (el, binding, vnode) {
//          if(binding.value.toString().length>=5){
//            el.style="font-size:1.1rem";
//          }else if(binding.value.toString().length>=3){
//            el.style="font-size:1.2rem";
//          }
        }
      }
    },
    created(){
      if (this.item.Quan_time) {
        this.isShowQuan = true;
        this.quanDesc = "券后价";
      } else {
        this.isShowQuan = false;
        this.quanDesc = "优惠价";
      }
//      console.log("isweixin ? ===>")
//      console.log(this.isWeixin)
    },
    mounted(){

    },
    methods: {
      returnClassName(isBaoYou){
        if (this.item.IsTmall == "1") {
          if (isBaoYou) {
            return this.type == this.showType.APP ? 'list-price-tmall-bao' : 'list-price-tmall-bao-h5';
          } else {
            return this.type == this.showType.APP ? 'list-price-tmall' : 'list-price-tmall-h5';
          }
        } else {
          if (isBaoYou) {
            return this.type == this.showType.APP ? 'list-price-tao-bao' : 'list-price-tao-bao-h5';
          } else {
            return this.type == this.showType.APP ? 'list-price-tao' : 'list-price-tao-h5';
          }
        }
      },
      showClass(){
        if (this.item.sourceType == 50 || this.item.sourceType == 51){
          return this.type == this.showType.APP ? 'list-price-jd-bao' : 'list-price-jd-bao-h5';
        } else if(this.item.sourceType == 70 || this.item.sourceType == 71) {
          return this.type == this.showType.APP ? 'list-price-pdd-bao' : 'list-price-pdd-bao-h5';
        } else if (this.item.sourceType == 7 && !this.item.freePost) {
          return this.returnClassName(false);
        } else {
          return this.returnClassName(true);
        }
      },
      updatePicSrc(pic){
        let src = pic.replace("http://", "//").replace("https://", "//");
        if (src.indexOf("taobaocdn.") > -1) {
          src = src.split("taobaocdn.")[1];
          src = "//img.alicdn." + src;
        }
        if (src.indexOf("alicdn") > -1) {
          src += "_300x300.jpg";
        }
        return src;
      },
      returnScore(){
        var ji = this.item.CommissionNum;
        if (ji >= 10) {
          ji = this.item.Price * 2;
        } else if (ji >= 5 && ji < 10) {
          ji = this.item.Price;
        } else if (ji >= 1 && ji < 5) {
          ji = this.item.Price / 2;
        } else if (ji >= 0.5 && ji < 1) {
          ji = this.item.Price / 5;
        } else {
          ji = this.item.Price;
        }
        return Math.ceil(ji);
      }
    }
  }
</script>
<style scoped>
  a {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// Double.vue?8390dc7a